import { render, staticRenderFns } from "./beginErrorTestMsgBox.vue?vue&type=template&id=f6d743b6&scoped=true&"
import script from "./beginErrorTestMsgBox.vue?vue&type=script&lang=js&"
export * from "./beginErrorTestMsgBox.vue?vue&type=script&lang=js&"
import style0 from "./beginErrorTestMsgBox.vue?vue&type=style&index=0&id=f6d743b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6d743b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
